const QuestionModel = [
  {
    field: 'alcoholFollowup_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },

  {
    field: 'alcoholFollowup_heightFeet',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'alcoholFollowup_heightFeet'
    }
  },
  {
    field: 'alcoholFollowup_weightPounds',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'alcoholFollowup_weightPounds'
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'alcoholFollowup_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the changes in your health',
    field: 'alcoholFollowup_healthChangesDetails',
    type: 'info',
    answer: {
      name: 'alcoholFollowup_healthChangesDetails',
      type: 'text',
      placeholder: 'Describe your health changes'
    }
  },
  {
    label:
      'Compared to before you started on this medication, how much do you drink now?',
    field: 'alcoholFollowup_medicationEffectOnDrinking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'stopped',
          value: 'I have completely stopped drinking'
        },
        {
          key: 'significantlyReduced',
          value:
            'I have significantly reduced the amount of alcohol that I drink ' //  >>> DISPLAY following conditional questions'
        },
        {
          key: 'slightReducation',
          value: 'I have slightly reduced how much alcohol that I drink' //  >>> DISPLAY following conditional questions'
        },
        {
          key: 'sameAmount',
          value: 'I drink the same amount of alcohol' //  >>> DISPLAY following conditional questions'
        },
        {
          key: 'moreDrinking',
          value: 'I drink more alcohol now' //  >>> DISPLAY following conditional questions'
        }
      ]
    }
  },
  {
    label: 'How many drinks do you consume per weekday?',
    field: 'alcoholFollowup_drinksConsumedPerWeekDay',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: '1-3',
          value: '1-3 drinks per day'
        },
        {
          key: '4to5',
          value: '4-5 drinks per day'
        },
        {
          key: '6to10',
          value: '6-10 drinks per day'
        },
        {
          key: '11orMore',
          value: '11 or more drinks per day'
        }
      ]
    }
  },

  {
    label: 'How many drinks do you consume per weekend day?',
    field: 'alcoholFollowup_drinksConsumedPerWeekendDay',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: '1-3',
          value: '1-3 drinks per day'
        },
        {
          key: '4-5',
          value: '4-5 drinks per day'
        },
        {
          key: '6-1',
          value: '6-10 drinks per day'
        },
        {
          key: '11orMore',
          value: '11 or more drinks per day'
        }
      ]
    }
  },
  {
    label:
      'Since starting the medication, how long does it take to get through a drink now?',
    field: 'alcoholFollowup_timespanOfSingleDrink',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'slower',
          value: 'I have noticed that it takes longer to finish a drink'
        },
        {
          key: 'noDifference',
          value: 'I haven’t noticed a difference since starting the medication'
        },
        {
          key: 'faster',
          value: 'I believe I drink faster now'
        }
      ]
    }
  },

  {
    label:
      'Since starting this medication, have you noticed a decrease in cravings triggered by cues such as alcohol advertisements?',
    field: 'alcoholFollowup_cravingsFromCues',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'lessCraving',
          value:
            'I feel like I’m not as triggered by these since starting the medication'
        },
        {
          key: 'notNoticed',
          value: 'I haven’t noticed a difference'
        },
        {
          key: 'moreCravings',
          value: 'I feel like the cues cause more cravings now'
        },
        {
          key: 'dontKnow',
          value: 'I don’t know'
        }
      ]
    }
  },

  {
    label:
      'Since starting this medication, have you noticed a reduction in cravings when you’re around others who are drinking alcohol?',
    field: 'alcoholFollowup_cravingsFromOthersDrinking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'lessCraving',
          value:
            'I feel like I’m not as triggered by this since starting the medication'
        },
        {
          key: 'notNoticed',
          value: 'I haven’t noticed a difference'
        },
        {
          key: 'moreCravings',
          value: 'I feel like this cause more cravings now'
        },
        {
          key: 'dontKnow',
          value: 'I don’t know'
        }
      ]
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'alcoholFollowup_sideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the side effects you are experiencing',
    field: 'alcoholFollowup_sideEffectsDetails',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'alcoholFollowup_sideEffectsDetails'
    }
  },
  {
    label:
      'Would you like to continue your current treatment, change the dose, or change the medication?',
    field: 'alcoholFollowup_continueTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'doingWellMaintain',
          value: 'I’m doing well and I would like to continue what I’m on'
        },
        {
          key: 'increaseDosage',
          value: 'I like the medication but I would like to increase the dose'
        },
        {
          key: 'decreaseDosage',
          value: 'I like the medication but I would like to decrease the dose'
        },
        {
          key: 'changeMedication',
          value: 'I would like to change the medication '
        },
        {
          key: 'discuss',
          value: 'I’m not sure, have the provider reach out to discuss further'
        }
      ]
    }
  },

  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'alcoholFollowup_questionsForDoctor',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'alcoholFollowup_questionsForDoctor'
    }
  },
  {
    class: 'ineligible',
    field: 'alcoholFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    isLast: true,
    answer: {}
  },
  {
    field: 'alcoholFollowup_complete',
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    extras: { sendToBeluga: false },
    isLast: true,
    answer: {}
  },
  {
    field: 'alcoholFollowup_truthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

I verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'non_consent',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  },
  {
    field: 'alcoholFollowup_pharmacotherapy',
    label:
      'Consent (Pharmacotherapy to Reduce Alcohol Cravings (Naltrexone or Baclofen)):',
    type: 'select',
    educationalSlide: `Please read the following information to understand the potential benefits and risks of either naltrexone or baclofen for reducing cravings for alcohol. These medications are intended to support your efforts to cut back on drinking and maintain safer, healthier habits.

    Indication for Use:
    You are considering treatment with naltrexone or baclofen as part of a comprehensive plan to reduce alcohol cravings and support decreased alcohol use.
     
    - Naltrexone works by blocking opioid receptors involved in the reward pathways of alcohol, helping to lessen the pleasurable effects of drinking and reduce the urge to drink.
    - Baclofen is a muscle relaxant that acts on GABA‑B receptors in the brain, which may help curb the reinforcing effects of alcohol and decrease cravings.

    Potential Benefits:
    - Reduced intensity and frequency of alcohol cravings
    - Decreased overall alcohol consumption
    - Support for longer periods of abstinence or low‑risk drinking
    - Improvement in mood, sleep, and daily functioning as drinking decreases
  
    Potential Side Effects:

    - Naltrexone
        - Common: Nausea, headache, dizziness, fatigue
        - Less Common but Serious: Elevated liver enzymes or liver injury (especially at higher doses); allergic reactions

    - Baclofen
        - Common: Drowsiness or sedation, dizziness, weakness, nausea
        - Less Common but Serious: Confusion, respiratory depression (at high doses), potential for baclofen withdrawal if stopped abruptly

    
    Risks and Considerations:

    - Naltrexone should not be used if you are currently on opioids or have acute hepatitis or significant liver impairment. Inform your provider of any opioid use (including for pain or opioid replacement therapy).
    - Baclofen requires caution if you have kidney impairment (dose adjustment may be necessary) or a history of seizure disorders. Abrupt discontinuation can lead to serious withdrawal symptoms, including increased anxiety, insomnia, or seizures.

    Certain medical conditions or medications may make one or both drugs unsuitable for you; please discuss your full medical history, including any pregnant or breastfeeding status, with your provider.

    Monitoring and Follow‑Up:
    Regular check‑ins to assess cravings, side effects, and medication adherence
      - Dose adjustments based on effectiveness and tolerability
      - Ongoing engagement with counseling, support groups, or other psychosocial interventions

    Acknowledgment & Consent:
    By signing below, you acknowledge that you have read and understood the information about naltrexone and baclofen, including their mechanisms, potential benefits, side effects, risks, and monitoring requirements. You agree to proceed with the prescribed medication plan and to maintain scheduled follow‑up appointments for safe and effective treatment.
`,
    answer: {
      type: 'single_select',
      options: [
        {
          class: 'option-decline',
          key: 'non_consent',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          class: 'option-consent',
          key: 'consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  }
] as const;

export default QuestionModel;
